import { Injectable } from '@angular/core';


export class MutationObserverService {
  public create(callback: any): MutationObserver {
    return new MutationObserver(callback);
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
